@if (selectedWorkspace$ | async; as selectedWorkspace) {
    <app-tb-menu
        #menu
        [container]="menuComponent"
        [replaceable]="true"
        yPosition="above"
        xPosition="before"
    >
        <div trigger data-testid="workspace-switch-trigger">
            <div
                class="flex items-center content-center cursor-pointer hover:bg-white hover:shadow-md rounded-lg py-1 pr-2 pl-4"
                [class]="menu.menuOpen ? 'shadow-md bg-white' : ''"
            >
                <div class="flex items-center">
                    <app-tb-icon
                        class="mr-2"
                        [icon]="getWorkspaceIcon(selectedWorkspace)"
                        [style.color]="getWorkspaceColor(selectedWorkspace)"
                    ></app-tb-icon>
                    <app-tb-tooltip-component
                        class="flex-1"
                        [tooltip]="getWorkspaceName(selectedWorkspace)"
                        tooltipPosition="below"
                        [showOnlyOnOverflow]="true"
                    >
                        <div
                            class="max-w-[160px] overflow-hidden subheading-2 whitespace-nowrap text-ellipsis"
                        >
                            {{ getWorkspaceName(selectedWorkspace) }}
                        </div>
                    </app-tb-tooltip-component>
                    <app-tb-icon
                        class="icon-m ml-2"
                        [icon]="menu.menuOpen ? 'expand_less' : 'expand_more'"
                        color="text"
                    ></app-tb-icon>
                </div>
            </div>
        </div>
    </app-tb-menu>
}
